/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportSubscriptionTransactionsVnf } from '../fn/vnf-subscription/export-subscription-transactions-vnf';
import { ExportSubscriptionTransactionsVnf$Params } from '../fn/vnf-subscription/export-subscription-transactions-vnf';
import { getSubscriptionBalance } from '../fn/vnf-subscription/get-subscription-balance';
import { GetSubscriptionBalance$Params } from '../fn/vnf-subscription/get-subscription-balance';
import { getSubscriptionsBalances } from '../fn/vnf-subscription/get-subscriptions-balances';
import { GetSubscriptionsBalances$Params } from '../fn/vnf-subscription/get-subscriptions-balances';
import { getTransactionsOfSubscriptionVnf } from '../fn/vnf-subscription/get-transactions-of-subscription-vnf';
import { GetTransactionsOfSubscriptionVnf$Params } from '../fn/vnf-subscription/get-transactions-of-subscription-vnf';
import { removeVehiclesToSubscriptionVnf } from '../fn/vnf-subscription/remove-vehicles-to-subscription-vnf';
import { RemoveVehiclesToSubscriptionVnf$Params } from '../fn/vnf-subscription/remove-vehicles-to-subscription-vnf';
import { SubscriptionBalance } from '../models/subscription-balance';
import { TransactionPagedList } from '../models/transaction-paged-list';
import { vehicleAddAuthSupportVnf } from '../fn/vnf-subscription/vehicle-add-auth-support-vnf';
import { VehicleAddAuthSupportVnf$Params } from '../fn/vnf-subscription/vehicle-add-auth-support-vnf';
import { vehicleRemoveAuthSupportVnf } from '../fn/vnf-subscription/vehicle-remove-auth-support-vnf';
import { VehicleRemoveAuthSupportVnf$Params } from '../fn/vnf-subscription/vehicle-remove-auth-support-vnf';


/**
 * All about the VNF subscription management
 */
@Injectable({ providedIn: 'root' })
export class VnfSubscriptionService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSubscriptionsBalances()` */
  static readonly GetSubscriptionsBalancesPath = '/custom/subscriptions/balances';

  /**
   * All subscriptions balances .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsBalances()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsBalances$Response(params: GetSubscriptionsBalances$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionBalance>>> {
    return getSubscriptionsBalances(this.http, this.rootUrl, params, context);
  }

  /**
   * All subscriptions balances .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsBalances$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsBalances(params: GetSubscriptionsBalances$Params, context?: HttpContext): Observable<Array<SubscriptionBalance>> {
    return this.getSubscriptionsBalances$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionBalance>>): Array<SubscriptionBalance> => r.body)
    );
  }

  /** Path part for operation `getSubscriptionBalance()` */
  static readonly GetSubscriptionBalancePath = '/custom/subscriptions/{uid}/balance';

  /**
   * Subscriptions balance .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionBalance()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionBalance$Response(params: GetSubscriptionBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionBalance>> {
    return getSubscriptionBalance(this.http, this.rootUrl, params, context);
  }

  /**
   * Subscriptions balance .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionBalance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionBalance(params: GetSubscriptionBalance$Params, context?: HttpContext): Observable<SubscriptionBalance> {
    return this.getSubscriptionBalance$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionBalance>): SubscriptionBalance => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfSubscriptionVnf()` */
  static readonly GetTransactionsOfSubscriptionVnfPath = '/custom/subscriptions/{uid}/transactions';

  /**
   * Search the transactions of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfSubscriptionVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfSubscriptionVnf$Response(params: GetTransactionsOfSubscriptionVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfSubscriptionVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfSubscriptionVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfSubscriptionVnf(params: GetTransactionsOfSubscriptionVnf$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfSubscriptionVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionTransactionsVnf()` */
  static readonly ExportSubscriptionTransactionsVnfPath = '/custom/subscriptions/{uid}/transactions/export';

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionTransactionsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactionsVnf$Response(params: ExportSubscriptionTransactionsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionTransactionsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionTransactionsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactionsVnf(params: ExportSubscriptionTransactionsVnf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionTransactionsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `removeVehiclesToSubscriptionVnf()` */
  static readonly RemoveVehiclesToSubscriptionVnfPath = '/custom/subscriptions/{uid}/vehicles/remove';

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeVehiclesToSubscriptionVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscriptionVnf$Response(params: RemoveVehiclesToSubscriptionVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeVehiclesToSubscriptionVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeVehiclesToSubscriptionVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscriptionVnf(params: RemoveVehiclesToSubscriptionVnf$Params, context?: HttpContext): Observable<void> {
    return this.removeVehiclesToSubscriptionVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleAddAuthSupportVnf()` */
  static readonly VehicleAddAuthSupportVnfPath = '/custom/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/assign';

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleAddAuthSupportVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupportVnf$Response(params: VehicleAddAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleAddAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleAddAuthSupportVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupportVnf(params: VehicleAddAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.vehicleAddAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleRemoveAuthSupportVnf()` */
  static readonly VehicleRemoveAuthSupportVnfPath = '/custom/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/remove';

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleRemoveAuthSupportVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupportVnf$Response(params: VehicleRemoveAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleRemoveAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleRemoveAuthSupportVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupportVnf(params: VehicleRemoveAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.vehicleRemoveAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
